import React, {Component, createRef, ReactNode, RefObject} from 'react'
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons';
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate';
import {BackLink} from '../../../styledComponents/adminPage/Links';
import {Messages} from '../../../Messages';
import {MESSAGE_TYPE, ROLE_FOR_ADMINISTRATOR} from '../../../CodeMaster';
import styled from 'styled-components';
import ReactToPrint from 'react-to-print';
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents';
import {createIconWithLevel} from '../../../styledComponents/adminPage/IconCreator';
import NatAuthKeyNoticePrintComponent from './NatAuthKeyNoticePrintComponent';
import {Colors} from '../../../styledComponents/Constants';
import {Nullable} from '../../../app/TypeHelpers';
import ConfirmationKeyNoticePrintComponent from './ConfirmationKeyNoticePrintComponent';

interface Props {
    title: string
    errorLevel: MESSAGE_TYPE
    message: string
    open: boolean
    printType: PRINT_TYPE
    loginUserRoleId: Nullable<string>
    isWarn: boolean

    closeDiaLogHandler: () => void
    printExecuteHandler: () => Promise<void>

    authKeyNoticeParams?: AuthKeyNoticeParams
    confirmationKeyNoticeParams?: ConfirmationKeyNoticeParams
}

export enum PRINT_TYPE {
    authKeyNotice,
    confirmationKeyNotice,
}

interface AuthKeyNoticeParams {
    condominiumName: string
    ridgeName: string
    roomNumber: string
    issueDate: string
    authenticationKey: string
    firstLoginAccessUrl: string
}

interface ConfirmationKeyNoticeParams {
    confirmationKey: string
    loginUrlWithConfirmationKey: string
}

export default class NatPrintDialogComponent extends Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    async componentDidMount(): Promise<void> {
    }

    createRefObject(): RefObject<any> {
        if (this.props.printType === PRINT_TYPE.authKeyNotice) {
            return createRef<NatAuthKeyNoticePrintComponent>();
        }
        if (this.props.printType === PRINT_TYPE.confirmationKeyNotice) {
            return createRef<ConfirmationKeyNoticePrintComponent>();
        }
        return createRef();
    }

    render(): ReactNode {
        const contentRef = this.createRefObject();
        return <>
            <Dialog
                scroll={'paper'}
                id={'pp-dialog'}
                open={this.props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                transitionDuration={(process.env.NODE_ENV === 'test') ? 0 : undefined}
                maxWidth={'xl'}
            >
                <DialogTitle id="alert-dialog-title">
                    <LeftRowFlexContainer>
                        {createIconWithLevel(this.props.errorLevel)}{this.props.title}
                    </LeftRowFlexContainer>
                </DialogTitle>
                <StyledDialogMessage>
                    <StyledDialogContentText id="alert-dialog-description">
                        {this.props.message}
                    </StyledDialogContentText>
                    {this.props.isWarn && this.props.printType === PRINT_TYPE.authKeyNotice &&
                     this.props.loginUserRoleId !== ROLE_FOR_ADMINISTRATOR.SYSTEM_ADMIN.value &&
                        <AlertDialogContentText id="alert-dialog-description">
                        {Messages.IRESA0013.toString()}
                        </AlertDialogContentText>
                    }
                </StyledDialogMessage>
                <StyledDialogContent>
                    <PageMainArea>
                        {this.props.printType === PRINT_TYPE.authKeyNotice && this.props.authKeyNoticeParams &&
                            <NatAuthKeyNoticePrintComponent
                                ref={contentRef}
                                condominiumName={this.props.authKeyNoticeParams.condominiumName}
                                ridgeName={this.props.authKeyNoticeParams.ridgeName}
                                roomNumber={this.props.authKeyNoticeParams.roomNumber}
                                issueDate={this.props.authKeyNoticeParams.issueDate}
                                authenticationKey={this.props.authKeyNoticeParams.authenticationKey}
                                firstLoginAccessUrl={this.props.authKeyNoticeParams.firstLoginAccessUrl}
                            />
                        }
                        {this.props.printType === PRINT_TYPE.confirmationKeyNotice &&
                            this.props.confirmationKeyNoticeParams &&
                            <ConfirmationKeyNoticePrintComponent
                                ref={contentRef}
                                confirmationKey={this.props.confirmationKeyNoticeParams.confirmationKey}
                                loginUrlWithConfirmationKey={
                                    this.props.confirmationKeyNoticeParams.loginUrlWithConfirmationKey
                                }
                            />
                        }
                    </PageMainArea>
                </StyledDialogContent>
                <StyledDialogActions>
                    <PageFooterArea>
                        <PageFotterAreaRight>
                            <ReactToPrint
                                trigger={() => (
                                    <AdminPrimaryButton onClick={this.props.printExecuteHandler}>
                                        印刷
                                    </AdminPrimaryButton>
                                )}
                                onAfterPrint={this.props.printExecuteHandler}
                                content={() => contentRef.current}/>
                        </PageFotterAreaRight>
                        <PageFotterAreaLeft>
                            <BackLink
                                onClick={this.props.closeDiaLogHandler}
                            >
                                キャンセル
                            </BackLink>
                        </PageFotterAreaLeft>
                    </PageFooterArea>
                </StyledDialogActions>
            </Dialog>
        </>
    }
}

const StyledDialogMessage = styled(DialogContent)`
  min-height: 120px;
`;

const StyledDialogContent = styled(DialogContent)`
  padding-left: 12px !important;
  padding-right: 12px !important;

  &.MuiDialogContent-root {
    padding: 0px 24px 8px 24px;
    margin: 4px 24px 10px 24px;
  }
  min-width: 820px;
`;

const StyledDialogActions = styled(DialogActions)`
  padding-left: 12px !important;
  padding-right: 12px !important;
`;

const AlertDialogContentText = styled(DialogContentText)`
  &.MuiDialogContentText-root {
    color: ${Colors.Alert};
    white-space: pre-line;
  }
`;

const StyledDialogContentText = styled(DialogContentText)`
    &.MuiDialogContentText-root {
        color: rgba(0, 0, 0, 0.87);
    }
`;
